import React, { useEffect, useState, useRef, createElement, Component } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { WaterTribeFestTicketSelection } from '../components/WaterTribeFestTicketSelection';
import { WaterTribeFestPrePaymentForm } from '../components/WaterTribeFestPrePaymentForm';
import { motion, AnimatePresence } from 'framer-motion';
import { Waves, Heart, GraduationCap, Target, Sparkles, Music, Zap, Users, Calendar, MapPin, CheckCircle2, Flame, MessageCircle, CreditCard, Lock } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { generateOrderNumber } from '../utils/orderNumber';
import { openTranzilaPayment } from '../utils/tranzila';
const activities = [{
  icon: Waves,
  title: 'חתירות חוויתיות ותחרותיות',
  description: 'מקצים עממיים ותחרותיים לכל הרמות בסאפ, רייס, קיאק וסרפסקי.',
  image: 'https://cdn.magicpatterns.com/uploads/81TuRkRozsSneXuE9PPvfp/IMG-20250201-WA0062.jpg'
}, {
  icon: Heart,
  title: 'חוויות גוף-נפש',
  description: 'יוגה, פילאטיס מחזק ואמבטיית קרח מודרכת להתאוששות',
  image: 'https://cdn.magicpatterns.com/uploads/oRhKrcQ2puhfgDX5hZr1xf/IMG-20250513-WA0010.jpg'
}, {
  icon: GraduationCap,
  title: 'סדנאות חתירה',
  description: 'שיפור טכניקה, הרצאות והדרכות עם המאמנים המובילים בארץ',
  image: 'https://cdn.magicpatterns.com/uploads/o9c53mVsS3VW85WhRtdH5V/IMG-20251017-WA0049.jpg'
}, {
  icon: Target,
  title: 'תכני העשרה',
  description: 'הרצאות השראה, סדנאות ועוד מלא הפתעות',
  image: 'https://cdn.magicpatterns.com/uploads/jv9JCKZ7rbuxPY1UBjZSNt/IMG-20251007-WA0003.jpg'
}, {
  icon: Music,
  title: 'מוזיקה ואווירת חוף',
  description: 'וחה מסיבת שקיעה, בירה קרה ואנשים טובים.',
  image: 'https://cdn.magicpatterns.com/uploads/ogPVnt7wGEJk1JMJE6qQr3/IMG-20250919-WA0024.jpg'
}, {
  icon: Users,
  title: 'מפגש קהילתי',
  description: 'כל קהילת המים של ישראל במקום אחד - הזדמנות להכיר ולהתחבר',
  image: 'https://cdn.magicpatterns.com/uploads/jthr15SsJsNm2nReM2yG6L/IMG-20250201-WA0077.jpg'
}, {
  icon: Sparkles,
  title: 'התנסות בציוד חדשני',
  description: 'הזדמנות לנסות את הציוד המתקדם ביותר עם המותגים המובילים בארץ ובעולם',
  image: 'https://cdn.magicpatterns.com/uploads/7Nsyyb3XcL22vTisSrbp26/file_00000000c840720c8d220c7d5f9e2f7f_(1).png'
}];
const audience = ['חותרות וחותרים, אוהבי ספורט וספורט ימי בכל הרמות', 'חותרים מקצועיים שרוצים להתחרות ולהשתפר', 'מתחילים שרוצים לנסות לראשונה ולהתאהב בים', 'חובבי תנועה, בריאות ולייף-סטייל', 'חובבי ים שרוצים חוויה של חופש', 'כל מי שמחפש חוויה ייחודית, מהנה וקהילתית במים וביבשה'];
const reasons = [{
  title: 'האירוע היחיד מסוגו',
  description: 'שילוב נדיר של מקצועיות, חוויה וקהילה ביום אחד מרוכז'
}, {
  title: 'ציוד בלעדי',
  description: 'הזדמנות לנסות כלים וציוד שלא נגישים ביום-יום'
}, {
  title: 'האנשים הנכונים',
  description: 'לפגוש את המדריכים והחותרים שהופכים את עולם המים למה שהוא'
}, {
  title: 'לוקיישן מושלם',
  description: 'חוף מעגן עדן - רצועת החוף היפה והאקסקלוסיבית ביותר בכנרת'
}];
export function WaterTribeFestPage() {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [showPrePaymentForm, setShowPrePaymentForm] = useState(false);
  const [selectedTicketName, setSelectedTicketName] = useState('');
  const [showIframe, setShowIframe] = useState(false);
  const [pendingTicket, setPendingTicket] = useState<{
    price: number;
    name: string;
    priceDisplay: string;
    ticketType?: 'festival-only' | 'accommodation' | 'double-alone';
  } | null>(null);
  const iframeRef = useRef<HTMLIFrameElement>(null);
  useEffect(() => {
    ;
    (window as any).openWaterTribeFestRegistrationForm = () => setIsFormOpen(true);
    document.title = 'Water Tribe Fest 2026 - פסטיבל החתירה של ישראל';
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'פסטיבל החתירה השנתי בכנרת. סאפ, קיאקים, יוגה, סדנאות, הופעות וקהילה.');
    const ogTags = [{
      property: 'og:title',
      content: 'Water Tribe Fest 2026 - פסטיבל החתירה של ישראל'
    }, {
      property: 'og:description',
      content: '12-14 במרץ 2026 | חוף מעגן עדן, כנרת.'
    }, {
      property: 'og:type',
      content: 'website'
    }, {
      property: 'og:image',
      content: 'https://cdn.magicpatterns.com/uploads/81TuRkRozsSneXuE9PPvfp/IMG-20250201-WA0062.jpg'
    }, {
      property: 'og:url',
      content: window.location.href
    }];
    ogTags.forEach(tag => {
      let metaTag = document.querySelector(`meta[property="${tag.property}"]`);
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute('property', tag.property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', tag.content);
    });
  }, []);
  const handleTicketSelect = (price: number, name: string, priceDisplay: string) => {
    // Store ticket info and open pre-payment form
    // Determine ticket type based on name
    let ticketType: 'festival-only' | 'accommodation' | 'double-alone' = 'accommodation';
    if (name.includes('פסטיבל בלבד')) {
      ticketType = 'festival-only';
    } else if (name.includes('חדר זוגי לבד')) {
      ticketType = 'double-alone';
    }
    setSelectedTicketName(name);
    setPendingTicket({
      price,
      name,
      priceDisplay,
      ticketType
    });
    setShowPrePaymentForm(true);
    // Track Meta Pixel event - Ticket Selected
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: name,
        content_category: 'Festival Ticket',
        value: price,
        currency: 'ILS'
      });
    }
  };
  const handlePrePaymentFormSubmit = async (formData: any) => {
    // Generate unique order number
    const orderNumber = generateOrderNumber();
    // Map form data to proper format
    const submissionData = {
      name: formData.fullName,
      phone: formData.phone,
      email: formData.email,
      orderNumber: orderNumber,
      ticketType: pendingTicket?.name || '',
      price: pendingTicket?.priceDisplay || '',
      gender: formData.gender === 'male' ? 'זכר' : formData.gender === 'female' ? 'נקבה' : '',
      nightChoice: formData.nightChoice === 'thursday' ? 'חמישי' : formData.nightChoice === 'friday' ? 'שישי' : '',
      roomType: formData.roomType === 'double' ? 'זוגי' : formData.roomType === 'triple' ? 'טריפל' : '',
      roommate1: formData.roommate1Name || '',
      roommate2: formData.roommate2Name || '',
      competitiveTrack: formData.competitiveTrack && formData.competitiveTrack.length > 0 ? formData.competitiveTrack.map((t: string) => {
        if (t === 'no') return 'לא';
        if (t === 'sprint') return 'ספרינט';
        if (t === 'technical') return 'טכני';
        if (t === 'longDistance') return 'לונג דיסטנס';
        return t;
      }).join(', ') : 'לא',
      rowingType: formData.rowingType === 'sup' ? 'סאפ' : formData.rowingType === 'race' ? 'רייס' : formData.rowingType === 'surfski' ? 'סרפסקי' : formData.rowingType === 'surfer' ? 'גולש' : formData.rowingType === 'atmosphere' ? 'סופג אווירה' : '',
      clubName: formData.belongsToClub === 'yes' && formData.clubName ? formData.clubName : 'לא שייך למועדון',
      rentBoard: formData.rentBoard === 'yes' ? 'כן' : formData.rentBoard === 'no' ? 'לא' : '',
      whatsappGroup: formData.whatsappGroup ? 'כן' : 'לא',
      type: 'הרשמה Water Tribe Fest',
      source: 'טופס תשלום'
    };
    // Store order details in localStorage for thank you page
    localStorage.setItem('pendingOrder', JSON.stringify({
      orderNumber: orderNumber,
      name: formData.fullName,
      email: formData.email,
      timestamp: Date.now()
    }));
    // Store registration data for Make.com webhook (sent after payment success)
    localStorage.setItem('pendingRegistrationData', JSON.stringify(submissionData));
    console.log('📦 Registration data stored, waiting for payment...');
    // Close the form
    setShowPrePaymentForm(false);
    // Track Meta Pixel event - Initiate Checkout
    if (window.fbq && pendingTicket) {
      window.fbq('track', 'InitiateCheckout', {
        content_name: pendingTicket.name,
        content_category: 'Festival Ticket',
        value: pendingTicket.price,
        currency: 'ILS',
        num_items: 1
      });
    }
    // Show iframe container
    setShowIframe(true);
    // Open Tranzila payment using the utility function
    if (pendingTicket) {
      // Small delay to ensure iframe is rendered
      setTimeout(() => {
        openTranzilaPayment({
          sum: pendingTicket.price,
          contact: formData.fullName,
          email: formData.email,
          phone: formData.phone,
          pdesc: `Water Tribe Fest 2026 - ${pendingTicket.name}`,
          success_url: `${window.location.origin}/tranzila-success`,
          fail_url: `${window.location.origin}/water-tribe-fest`,
          u1: orderNumber,
          u2: pendingTicket.name,
          u3: pendingTicket.priceDisplay
        });
        // Scroll to iframe after submission
        setTimeout(() => {
          iframeRef.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }, 100);
      }, 100);
    }
  };
  return <div className="min-h-screen bg-white" dir="rtl" data-id="element-1234">
      <Navigation data-id="element-1235" />

      {/* Hero */}
      <div className="relative h-screen min-h-[600px] overflow-hidden flex items-center justify-center" data-id="element-1236">
        <div className="absolute inset-0 bg-gradient-to-b from-blue-900/40 via-blue-800/20 to-[#0A5F8F]/90 z-10" data-id="element-1237" />
        <video autoPlay muted loop playsInline className="absolute inset-0 w-full h-full object-cover" data-id="element-1238">
          <source src="https://cdn.magicpatterns.com/uploads/bHRRxzcgoWuLZVsSMLwyGt/VID-20251224-WA0026.undefined" type="video/mp4" data-id="element-1239" />
        </video>
        <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white to-transparent z-20" data-id="element-1240" />

        <div className="relative z-30 container mx-auto px-4 text-center text-white" data-id="element-1241">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-1242">
            <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-md px-4 py-2 rounded-full mb-6 border border-white/30" data-id="element-1243">
              <Calendar className="w-5 h-5" data-id="element-1244" />
              <span className="font-medium" data-id="element-1245">12-14 במרץ 2026</span>
              <span className="mx-2" data-id="element-1246">|</span>
              <MapPin className="w-5 h-5" data-id="element-1247" />
              <span data-id="element-1248">חוף מעגן עדן, כנרת</span>
            </div>

            <h1 className="text-6xl md:text-8xl font-black mb-4 tracking-tight drop-shadow-lg" data-id="element-1249">
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-cyan-300 to-white" data-id="element-1250">
                WATER TRIBE
              </span>
              <span className="block mt-2" data-id="element-1251">FEST 2026</span>
            </h1>

            <p className="text-2xl md:text-4xl font-light mb-12 text-blue-100 max-w-3xl mx-auto" data-id="element-1252">
              פסטיבל החתירה השנתי של ישראל
            </p>

            <Button variant="outline" className="border-white text-white hover:bg-white hover:text-[#0A5F8F] text-lg px-8 py-6" onClick={() => {
            document.getElementById('pricing-section')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} data-id="element-1253">
              להרשמה המשיכו לגלול למטה ↓
            </Button>
          </motion.div>
        </div>
      </div>

      {/* Story */}
      <section className="py-12 bg-white" data-id="element-1254">
        <div className="container mx-auto px-4" data-id="element-1255">
          <div className="max-w-4xl mx-auto text-center" data-id="element-1256">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-4xl md:text-6xl font-bold text-[#0A5F8F] mb-8" data-id="element-1257">
              זה לא עוד אירוע ספורט
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="text-xl md:text-2xl text-gray-600 leading-relaxed" data-id="element-1258">
              זה סופשבוע אחד שמאחד את כל תרבות החתירה בישראל:
              <br data-id="element-1259" />
              <span className="font-bold text-gray-900" data-id="element-1260">
                מים, קהילה, חוויה וגופנפש.
              </span>
            </motion.p>
          </div>
        </div>
      </section>

      {/* Activities */}
      <section className="py-16 bg-gray-50" data-id="element-1261">
        <div className="container mx-auto px-4" data-id="element-1262">
          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} className="text-center mb-16" data-id="element-1263">
            <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-4" data-id="element-1264">
              מה מחכה לכם בפסטיבל?
            </h2>
            <p className="text-xl text-gray-600" data-id="element-1265">
              הפסטיבל שמאגד את כל מה שאתם אוהבים בים - בסופשבוע אחד
            </p>
          </motion.div>

          <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1266">
            {activities.map((activity, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className={`rounded-3xl shadow-lg hover:shadow-xl transition-all border border-gray-100 overflow-hidden h-full min-h-[300px] relative ${index === activities.length - 1 ? 'col-span-2 md:col-span-2 lg:col-span-1 lg:col-start-2' : ''}`} data-id="element-1267">
                <div className="absolute inset-0" data-id="element-1268">
                  <img src={activity.image} alt={activity.title} className={`w-full h-full object-cover ${activity.imagePosition || 'object-center'}`} data-id="element-1269" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent" data-id="element-1270" />
                </div>
                <div className="relative z-10 p-8 h-full flex flex-col justify-end" data-id="element-1271">
                  <h3 className="text-xl font-bold text-white mb-2" data-id="element-1272">
                    {activity.title}
                  </h3>
                  <p className="text-gray-200 text-sm leading-relaxed" data-id="element-1273">
                    {activity.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Who Should Come */}
      <section className="py-24 bg-[#0A5F8F] text-white relative overflow-hidden" data-id="element-1274">
        <div className="absolute top-0 right-0 w-96 h-96 bg-white/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-1275" />
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-cyan-400/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-1276" />

        <div className="container mx-auto px-4 relative z-10" data-id="element-1277">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-1278">
            <motion.div initial={{
            opacity: 0,
            x: 50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} data-id="element-1279">
              <h2 className="text-5xl md:text-6xl font-bold mb-8 leading-tight" data-id="element-1280">
                למי הפסטיבל
                <br data-id="element-1281" />
                <span className="text-cyan-300" data-id="element-1282">מתאים?</span>
              </h2>
              <p className="text-xl text-blue-100 mb-8 max-w-md" data-id="element-1283">
                בין אם אתם חותרים מקצועיים או שמעולם לא עליתם על סאפ - הפסטיבל
                הזה הוא בשבילכם.
              </p>
            </motion.div>

            <div className="space-y-4" data-id="element-1284">
              {audience.map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -30
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex items-center gap-4 bg-white/10 backdrop-blur-sm p-4 rounded-xl border border-white/10" data-id="element-1285">
                  <div className="bg-cyan-400 rounded-full p-1 shrink-0" data-id="element-1286">
                    <CheckCircle2 className="w-5 h-5 text-[#0A5F8F]" data-id="element-1287" />
                  </div>
                  <span className="text-lg font-medium" data-id="element-1288">{item}</span>
                </motion.div>)}
            </div>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mt-12" data-id="element-1289">
            <Button size="lg" className="bg-cyan-400 text-[#0A5F8F] hover:bg-cyan-300 px-12 py-6 rounded-full shadow-xl text-lg font-bold" onClick={() => {
            document.getElementById('pricing-section')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} data-id="element-1290">
              להרשמה המשיכו לגלול למטה ↓
            </Button>
          </motion.div>
        </div>
      </section>

      {/* Why Miss (FOMO) */}
      <section className="py-24 bg-gradient-to-br from-orange-50 to-rose-50" data-id="element-1291">
        <div className="container mx-auto px-4" data-id="element-1292">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-16" data-id="element-1293">
            <div className="inline-flex items-center gap-2 bg-orange-100 text-orange-600 px-4 py-1 rounded-full font-bold mb-4" data-id="element-1294">
              <Flame className="w-5 h-5" data-id="element-1295" />
              <span data-id="element-1296">FOMO ALERT</span>
            </div>
            <h2 className="text-4xl md:text-6xl font-black text-gray-900 mb-6" data-id="element-1297">
              למה אסור לפספס?
            </h2>
          </motion.div>

          <div className="max-w-5xl mx-auto" data-id="element-1298">
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-orange-100" data-id="element-1299">
              <ul className="space-y-4" data-id="element-1300">
                {reasons.map((reason, index) => <motion.li key={index} initial={{
                opacity: 0,
                x: -30
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: index * 0.1
              }} className="flex items-start gap-4" data-id="element-1301">
                    <div className="bg-orange-100 rounded-full p-1 shrink-0 mt-1" data-id="element-1302">
                      <CheckCircle2 className="w-5 h-5 text-orange-600" data-id="element-1303" />
                    </div>
                    <div data-id="element-1304">
                      <h3 className="text-xl font-bold text-gray-900 mb-1" data-id="element-1305">
                        {reason.title}
                      </h3>
                      <p className="text-gray-600" data-id="element-1306">{reason.description}</p>
                    </div>
                  </motion.li>)}
              </ul>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Accommodation */}
      <section className="py-24 bg-gradient-to-br from-blue-50 to-cyan-50" data-id="element-1307">
        <div className="container mx-auto px-4" data-id="element-1308">
          <div className="max-w-5xl mx-auto" data-id="element-1309">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-center mb-12" data-id="element-1310">
              <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-600 px-4 py-2 rounded-full font-bold mb-4" data-id="element-1311">
                <Calendar className="w-5 h-5" data-id="element-1312" />
                <span data-id="element-1313">לוח זמנים</span>
              </div>
              <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-4" data-id="element-1314">
                מה לו"ז האירוע?
              </h2>
              <p className="text-xl text-gray-600 mb-8" data-id="element-1315">
                שלושה ימים מלאים בפעילויות, חוויות וקהילה
              </p>
            </motion.div>

            <div className="space-y-8 mb-16" data-id="element-1316">
              {/* Thursday */}
              <motion.div initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-3xl p-8 shadow-lg border border-blue-100" data-id="element-1317">
                <h3 className="text-3xl font-bold text-[#0A5F8F] mb-6 flex items-center gap-3" data-id="element-1318">
                  <Calendar className="w-8 h-8" data-id="element-1319" />
                  יום חמישי, 12.3.2026
                </h3>
                <div className="space-y-4" data-id="element-1320">
                  {[{
                  time: '14:00 - 15:00',
                  activity: 'הגעה, קבלת חדרים והרשמה'
                }, {
                  time: '15:00 - 16:00',
                  activity: 'מקצה ספרינטים'
                }, {
                  time: '16:30 - 18:00',
                  activity: 'חתירת שקיעה'
                }, {
                  time: '20:00 - 21:00',
                  activity: 'הרצאת השראה'
                }].map((item, index) => <div key={index} className="flex items-start gap-4 bg-white/60 p-4 rounded-xl flex-row-reverse" data-id="element-1321">
                      <div className="bg-blue-600 text-white px-4 py-2 rounded-lg font-bold text-sm whitespace-nowrap shrink-0" data-id="element-1322">
                        {item.time}
                      </div>
                      <div className="text-gray-800 font-medium pt-2 text-right" data-id="element-1323">
                        {item.activity}
                      </div>
                    </div>)}
                </div>
              </motion.div>

              {/* Friday */}
              <motion.div initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.1
            }} className="bg-gradient-to-br from-cyan-50 to-teal-50 rounded-3xl p-8 shadow-lg border border-cyan-100" data-id="element-1324">
                <h3 className="text-3xl font-bold text-[#0A5F8F] mb-6 flex items-center gap-3" data-id="element-1325">
                  <Calendar className="w-8 h-8" data-id="element-1326" />
                  יום שישי, 13.3.2026
                </h3>
                <div className="space-y-4" data-id="element-1327">
                  {[{
                  time: '7:00 - 7:45',
                  activity: 'יוגהלאטיס על סאפ'
                }, {
                  time: '8:00 - 9:00',
                  activity: 'מקצה טכני תחרותי'
                }, {
                  time: '9:00 - 11:00',
                  activity: 'יציאה לשני מסלולי חתירה חוויתיים לבחירה: מסלול מעגלי בדרום הכנרת - כ-10 ק"מ, ירדנית - 3 ק"מ'
                }, {
                  time: '11:00',
                  activity: 'פתיחת מתחם אקספו - הדגמות, התנסויות, מוסיקה ופינוקים'
                }, {
                  time: '11:30 - 13:30',
                  activity: 'סדנת חתירה למתחילים | סדנת טכניקה למתקדמים | סדנת אקרויוגה'
                }, {
                  time: '14:00 - 16:00',
                  activity: 'סדנת תיקונים עם זזיק | עקרונות החתירה בסרפסקי - אמיגו | מבוא לגלישת ווינג'
                }, {
                  time: '17:00 - 19:00',
                  activity: 'מסיבת חוף עם DJ'
                }].map((item, index) => <div key={index} className="flex items-start gap-4 bg-white/60 p-4 rounded-xl flex-row-reverse" data-id="element-1328">
                      <div className="bg-cyan-600 text-white px-4 py-2 rounded-lg font-bold text-sm whitespace-nowrap shrink-0" data-id="element-1329">
                        {item.time}
                      </div>
                      <div className="text-gray-800 font-medium pt-2 text-right" data-id="element-1330">
                        {item.activity}
                      </div>
                    </div>)}
                </div>
              </motion.div>

              {/* Saturday */}
              <motion.div initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.2
            }} className="bg-gradient-to-br from-teal-50 to-emerald-50 rounded-3xl p-8 shadow-lg border border-teal-100" data-id="element-1331">
                <h3 className="text-3xl font-bold text-[#0A5F8F] mb-6 flex items-center gap-3" data-id="element-1332">
                  <Calendar className="w-8 h-8" data-id="element-1333" />
                  יום שבת, 14.3.2026
                </h3>
                <div className="space-y-4" data-id="element-1334">
                  {[{
                  time: '7:00 - 7:45',
                  activity: 'מתיחות ותרגילי כוח על סאפ'
                }, {
                  time: '7:15',
                  activity: 'מסלול תחרותי Long Distance - 10 ק"מ'
                }, {
                  time: '9:00 - 10:30',
                  activity: 'יציאה למסלול חווייתי'
                }, {
                  time: '11:00',
                  activity: 'מקצה מועדונים - מירוץ שליחים'
                }, {
                  time: '12:30',
                  activity: 'פודיום, נשיקות וחיבוקים'
                }].map((item, index) => <div key={index} className="flex items-start gap-4 bg-white/60 p-4 rounded-xl flex-row-reverse" data-id="element-1335">
                      <div className="bg-teal-600 text-white px-4 py-2 rounded-lg font-bold text-sm whitespace-nowrap shrink-0" data-id="element-1336">
                        {item.time}
                      </div>
                      <div className="text-gray-800 font-medium pt-2 text-right" data-id="element-1337">
                        {item.activity}
                      </div>
                    </div>)}
                </div>
              </motion.div>
            </div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-center mb-12" data-id="element-1338">
              <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-600 px-4 py-2 rounded-full font-bold mb-4" data-id="element-1339">
                <MapPin className="w-5 h-5" data-id="element-1340" />
                <span data-id="element-1341">אירוח במקום</span>
              </div>
              <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-4" data-id="element-1342">
                שלושה ימים מלאים? הישארו לישון!
              </h2>
              <p className="text-xl text-gray-600" data-id="element-1343">
                כפר הנופש מעגן מציע אירוח נוח במחירים מיוחדים למשתתפי הפסטיבל
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-blue-100" data-id="element-1344">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-1345">
                <div data-id="element-1346">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-1347">
                    למה לישון במקום?
                  </h3>
                  <ul className="space-y-4" data-id="element-1348">
                    {['תתחילו את הבוקר ישר על החוף', 'לא תפספסו אף רגע מהפסטיבל', 'תיהנו ממסיבת הערב עד הסוף', 'מחירים מיוחדים למשתתפי הפסטיבל', 'חדרים נוחים וממוזגים'].map((item, index) => <li key={index} className="flex items-center gap-3" data-id="element-1349">
                        <div className="bg-blue-100 rounded-full p-1" data-id="element-1350">
                          <CheckCircle2 className="w-5 h-5 text-[#0A5F8F]" data-id="element-1351" />
                        </div>
                        <span className="text-gray-700" data-id="element-1352">{item}</span>
                      </li>)}
                  </ul>
                </div>
                <div className="bg-gradient-to-br from-[#0A5F8F] to-[#0D7AB8] rounded-2xl p-8 text-white text-center" data-id="element-1353">
                  <MapPin className="w-12 h-12 mx-auto mb-4" data-id="element-1354" />
                  <h4 className="text-2xl font-bold mb-2" data-id="element-1355">כפר הנופש מעגן</h4>
                  <p className="text-blue-100 mb-6" data-id="element-1356">
                    אירוח איכותי במחירים נוחים
                  </p>
                  <div className="space-y-3" data-id="element-1357">
                    <a href="https://www.maagan.co.il/category/%d7%94%d7%97%d7%93%d7%a8%d7%99%d7%9d/" target="_blank" rel="noopener noreferrer" className="block bg-white/20 hover:bg-white/30 backdrop-blur-sm px-6 py-3 rounded-xl transition-colors border border-white/30" data-id="element-1358">
                      <span className="font-medium" data-id="element-1359">תיאור החדרים</span>
                    </a>
                    <a href="https://www.maagan.co.il/%d7%a9%d7%90%d7%9c%d7%95%d7%aa-%d7%95%d7%aa%d7%a9%d7%95%d7%91%d7%95%d7%aa/uncategorized/" target="_blank" rel="noopener noreferrer" className="block bg-white/20 hover:bg-white/30 backdrop-blur-sm px-6 py-3 rounded-xl transition-colors border border-white/30" data-id="element-1360">
                      <span className="font-medium" data-id="element-1361">
                        מידע נוסף על כפר הנופש
                      </span>
                    </a>
                  </div>
                  <p className="text-sm text-blue-200 mt-4" data-id="element-1362">
                    מספר החדרים מוגבל - הזמינו מוקדם!
                  </p>
                </div>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-center mt-8" data-id="element-1363">
              <Button size="lg" className="bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white px-12 py-6 rounded-full shadow-xl" onClick={() => {
              document.getElementById('pricing-section')?.scrollIntoView({
                behavior: 'smooth'
              });
            }} data-id="element-1364">
                להרשמה המשיכו לגלול למטה ↓
              </Button>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="pricing-section" className="py-24 bg-gradient-to-br from-indigo-50 to-purple-50" data-id="element-1365">
        <div className="container mx-auto px-4" data-id="element-1366">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="max-w-6xl mx-auto" data-id="element-1367">
            <div className="text-center mb-12" data-id="element-1368">
              <div className="inline-flex items-center gap-2 bg-indigo-100 text-indigo-600 px-4 py-2 rounded-full font-bold mb-4" data-id="element-1369">
                <CreditCard className="w-5 h-5" data-id="element-1370" />
                <span data-id="element-1371">רכישת כרטיסים</span>
              </div>
              <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-4" data-id="element-1372">
                מחירי הפסטיבל
              </h2>
              <p className="text-xl text-gray-600 mb-8" data-id="element-1373">
                הרשמה מוקדמת עד ה-10.2.2026 | הרשמה רגילה מה-11.2.2026
              </p>

              {/* What's Included Section */}
              <motion.div initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} className="bg-gradient-to-br from-cyan-50 to-blue-50 rounded-3xl p-8 md:p-10 border border-cyan-100 shadow-lg mb-12" data-id="element-1374">
                <div className="flex items-start gap-4" data-id="element-1375">
                  <div className="bg-cyan-500 rounded-full p-3 shrink-0" data-id="element-1376">
                    <Sparkles className="w-6 h-6 text-white" data-id="element-1377" />
                  </div>
                  <div data-id="element-1378">
                    <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-1379">
                      מה כלול במחיר?
                    </h3>
                    <p className="text-lg text-gray-700 leading-relaxed" data-id="element-1380">
                      המחיר כולל השתתפות מלאה ב<strong data-id="element-1381">כ-ל</strong> חוויית
                      הפסטיבל – כל הסדנאות, הרצאות, חתירות, טבילה מרעננת
                      באמבטיית קרח, בירה קרה ועוד הפתעות 🎉
                    </p>
                  </div>
                </div>
              </motion.div>
            </div>

            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-1382">
              {[{
              name: 'הרשמה לפסטיבל- לינה בחדר זוגי/ טריפל',
              early: '1,190',
              regular: '1,322',
              price: 1190
            }, {
              name: 'הרשמה לפסטיבל- לינה בחדר זוגי לבד',
              early: '1,970',
              regular: '2,167',
              price: 1970
            }, {
              name: 'הרשמה לפסטיבל- לילה אחד (לילה של חמישי / שישי) בחדר זוגי',
              early: '850',
              regular: '935',
              price: 850
            }, {
              name: 'הרשמה לפסטיבל בלבד',
              early: '410',
              regular: '455',
              price: 410
            }].map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.05
            }} whileHover={{
              scale: 1.03,
              y: -5
            }} className={`bg-white rounded-3xl p-6 shadow-lg border transition-all cursor-pointer flex flex-col justify-between h-full relative overflow-hidden group ${selectedTicketName === item.name ? 'border-indigo-500 ring-2 ring-indigo-500 shadow-xl' : 'border-indigo-100 hover:shadow-xl hover:border-indigo-300'}`} onClick={() => handleTicketSelect(item.price, item.name, item.early)} data-id="element-1383">
                  <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-indigo-100 to-transparent rounded-bl-full -mr-4 -mt-4 opacity-50 group-hover:scale-110 transition-transform" data-id="element-1384" />

                  <div className="relative z-10" data-id="element-1385">
                    <h3 className="text-xl font-bold text-gray-900 mb-4 leading-tight min-h-[3.5rem]" data-id="element-1386">
                      {item.name}
                    </h3>

                    <div className="flex flex-col gap-1 mt-auto" data-id="element-1387">
                      <div className="flex items-baseline gap-2" data-id="element-1388">
                        <span className="text-4xl font-black text-indigo-600" data-id="element-1389">
                          ₪{item.early}
                        </span>
                        <span className="text-sm font-medium text-indigo-600 bg-indigo-50 px-2 py-1 rounded-full" data-id="element-1390">
                          הרשמה מוקדמת
                        </span>
                      </div>

                      <div className="flex items-center gap-2 mt-2" data-id="element-1391">
                        <span className="text-2xl line-through font-bold text-gray-500" data-id="element-1392">
                          ₪{item.regular}
                        </span>
                        <span className="text-xs font-semibold text-gray-500 bg-gray-100 px-2 py-1 rounded" data-id="element-1393">
                          מחיר רגיל
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="mt-6 pt-4 border-t border-gray-100 flex items-center justify-between text-sm font-medium text-indigo-600 group-hover:text-indigo-700" data-id="element-1394">
                    <span data-id="element-1395">
                      {selectedTicketName === item.name ? 'נבחר' : 'לחצו לתשלום'}
                    </span>
                    <div className={`rounded-full p-1 transition-colors ${selectedTicketName === item.name ? 'bg-indigo-600 text-white' : 'bg-indigo-50 group-hover:bg-indigo-100'}`} data-id="element-1396">
                      <CheckCircle2 className="w-4 h-4" data-id="element-1397" />
                    </div>
                  </div>
                </motion.div>)}
            </motion.div>

            {/* Iframe Container for Tranzila Payment */}
            <div className={`w-full bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100 transition-all duration-500 ${showIframe ? 'opacity-100 max-h-[700px] mt-12' : 'opacity-0 max-h-0 overflow-hidden'}`} data-id="element-1398">
              <div className="bg-gray-50 p-4 border-b border-gray-100 flex items-center justify-between" data-id="element-1399">
                <div className="flex items-center gap-2 text-gray-600" data-id="element-1400">
                  <Lock className="w-4 h-4" data-id="element-1401" />
                  <span className="text-sm font-medium" data-id="element-1402">
                    תשלום מאובטח באמצעות טרנזילה
                  </span>
                </div>
                <div className="text-sm font-bold text-[#0A5F8F]" data-id="element-1403">
                  {selectedTicketName}
                </div>
              </div>
              <iframe ref={iframeRef} name="tranzila" width="100%" height="600" frameBorder="0" allow="payment" className="w-full" data-id="element-1404"></iframe>
            </div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-center mt-8" data-id="element-1405">
              <Button size="lg" className="bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700 text-white px-12 py-6 rounded-full shadow-xl" onClick={() => {
              document.getElementById('pricing-section')?.scrollIntoView({
                behavior: 'smooth'
              });
            }} data-id="element-1406">
                הרשמה לפסטיבל
              </Button>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* WhatsApp Group Section */}
      <section className="py-24 bg-gradient-to-br from-green-50 to-emerald-50" data-id="element-1407">
        <div className="container mx-auto px-4" data-id="element-1408">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="max-w-3xl mx-auto text-center" data-id="element-1409">
            <div className="inline-flex items-center gap-2 bg-green-100 text-green-600 px-4 py-2 rounded-full font-bold mb-6" data-id="element-1410">
              <MessageCircle className="w-5 h-5" data-id="element-1411" />
              <span data-id="element-1412">הצטרפו לקהילה</span>
            </div>

            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-1413">
              קבוצת הווטסאפ השקטה של האירוע
            </h2>

            <p className="text-xl text-gray-600 mb-8 leading-relaxed" data-id="element-1414">
              הצטרפו לקבוצת הווטסאפ השקטה שלנו וקבלו עדכונים ראשונים על הפסטיבל,
              מחירים מיוחדים ופרטים חשובים
            </p>

            <motion.div whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} data-id="element-1415">
              <Button size="lg" className="bg-[#25D366] hover:bg-[#20BA5A] text-white text-xl px-12 py-8 rounded-full shadow-2xl shadow-green-500/30 inline-flex items-center gap-3" onClick={() => window.open('https://chat.whatsapp.com/BTCYcMWElUsEX6Ds48mQFA', '_blank')} data-id="element-1416">
                <MessageCircle className="w-6 h-6" data-id="element-1417" />
                הצטרפו לקבוצה
              </Button>
            </motion.div>

            <p className="mt-6 text-sm text-gray-500" data-id="element-1418">
              קבוצה שקטה - רק עדכונים חשובים מהצוות
            </p>
          </motion.div>
        </div>
      </section>

      {/* Sponsors Section */}
      <section className="py-16 bg-white border-t border-gray-100" data-id="element-1419">
        <div className="container mx-auto px-4" data-id="element-1420">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-12" data-id="element-1421">
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2" data-id="element-1422">
              תודה לנותני החסות
            </h3>
            <p className="text-lg text-gray-600" data-id="element-1423">שבזכותם כל זה לא היה קורה!</p>
          </motion.div>

          <div className="flex flex-col items-center justify-center gap-8 max-w-4xl mx-auto" data-id="element-1424">
            {/* First Row: Focus and Super Boards */}
            <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12" data-id="element-1425">
              <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.1
            }} className="flex items-center justify-center w-32 h-24 md:w-40 md:h-28" data-id="element-1426">
                <img src="https://cdn.magicpatterns.com/uploads/c9cqmiETssEvaaWTmgei9g/Screenshot_20260114_100258_Adobe_Acrobat~2.jpg" alt="Focus Hawaii" className="max-h-full max-w-full object-contain" data-id="element-1427" />
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.2
            }} className="flex items-center justify-center w-32 h-24 md:w-40 md:h-28" data-id="element-1428">
                <img src="https://cdn.magicpatterns.com/uploads/mv2v6jUXwPZU392ZcXr96e/tempFileForShare_20260114-101156.jpg" alt="Super Boards" className="max-h-full max-w-full object-contain" data-id="element-1429" />
              </motion.div>
            </div>

            {/* Second Row: Freefull, Yamit, Zazik */}
            <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12" data-id="element-1430">
              <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.3
            }} className="flex items-center justify-center w-32 h-24 md:w-40 md:h-28" data-id="element-1431">
                <img src="https://cdn.magicpatterns.com/uploads/jgUGGBjF8wH9kuTWb95A31/IMG-20240320-WA0021.jpg" alt="Freefull Sea Sports" className="max-h-full max-w-full object-contain" data-id="element-1432" />
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.4
            }} className="flex items-center justify-center w-32 h-24 md:w-40 md:h-28" data-id="element-1433">
                <img src="https://cdn.magicpatterns.com/uploads/2GpMhfwu9CXQAfHdGfWn5v/Screenshot_20260114_101728_Photos~2.jpg" alt="Yamit" className="max-h-full max-w-full object-contain" data-id="element-1434" />
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.5
            }} className="flex items-center justify-center w-32 h-24 md:w-40 md:h-28" data-id="element-1435">
                <img src="https://cdn.magicpatterns.com/uploads/73y5FStqEUKbtd3kEz9SFX/tempFileForShare_20260114-101936.jpg" alt="Zazik" className="max-h-full max-w-full object-contain" data-id="element-1436" />
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      <Footer data-id="element-1437" />
      <WaterTribeFestTicketSelection isOpen={isFormOpen} onClose={() => setIsFormOpen(false)} data-id="element-1438" />
      <WaterTribeFestPrePaymentForm isOpen={showPrePaymentForm} onClose={() => setShowPrePaymentForm(false)} onSubmit={handlePrePaymentFormSubmit} ticketName={pendingTicket?.name || ''} ticketPrice={pendingTicket?.priceDisplay || ''} ticketType={pendingTicket?.ticketType} data-id="element-1439" />
    </div>;
}